<template>
<div>
    <div class="form-container ou-donation-form ote-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Sponsorship Opportunities">
                    <div>
                        <AmountSelector/>                    
                        <ErrorLabel field="amount" />
                    </div>
                </FormSection>
                <FormSection title="Donation Frequency">
                	<div class="frequency">
                    <PaymentOptions addSplit addMonthly/>
                  </div>
                    <!-- <DonationFrequency />  -->
                </FormSection>								
                <FormSection title="Your Contact Information">
                    <FormRow inline>
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>  
										<FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>       	
										<br>				
                    <InHonorOf />
										<br>							
                </FormSection>                
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>	
                <FormSection title="Payment Info" last>
                  <div class="payment-info">
                    <FormRow>
                      <PaymentType cc_text="Credit Card" check_text="Check"/>
                    </FormRow>
                    <FormRow inline>
                      <FormCol class="doublepay" field="card" :showLabel="false" check_text=""/>
                    </FormRow>
										<FormRow v-if="form.gateway === 'check'" style="justify-content: center;" class="checktext">
										
												<div>Please mail your check to the following address:
												<p style="text-align:center;"><strong>New York NCSY<br>
												40 Rector St, 4th Floor<br>
												New York, NY 10006</strong>
                        <br>For further questions, please call (646) 459-5166</p></div>
                    </FormRow>																														
                  </div>
                </FormSection>
                <PaymentButton showAmount btnText="Donate"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({  setup(props) {
    const { form, setValue } = usePaymentForm()

    return {
      form,
      setValue
    }
  },
})
</script>

<style scoped lang="scss">

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.donate-intro{
	font-size: 18px;
	line-height: 26px;
	    color: #00346B;
	p{
		margin-bottom: 10px;
	}
	a{
		color: #00346B;
		font-weight: 600;
	}
}

.form-container.ou-donation-form.ote-donation-form{
    max-width: 770px !important;
		overflow: hidden;
		box-shadow: none;	
		padding: 20px !important;
	  @media only screen and (min-width: 720px) {
			padding: 30px ​50px !important;
			margin: 0px auto;
		}
}
.form-container.ou-donation-form.ote-donation-form h2{
    margin: 10px 0px 20px;
	  @media only screen and (min-width: 720px) {
    font-size: 28px;
		}
}
.ote-donation-form ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
	justify-content: space-between;

	label{
		border: 1px solid #0d346c;
		color: #000000;
		font-size: 15px;
		&:hover{
			background: #f7f7f7;
		}
	}
	input[type='radio']:checked + label {
    background: #0d346c;
  }
	input[type='radio']:checked + label .label-amount{
				background: #0d346c;
			border-color: #0d346c;
	}
	.label-description{
		font-size: 16px;
	}
	.label-amount{
		background: #0d346c;
    color: white;
	}
	.radio-part{
		min-width: 33%;
		line-height: 20px;
		max-width: 33%;
	}
}

.footer-links{
		text-align: center;
		font-size: 16px;
		margin: 50px auto 28px;
		line-height: 26px;
		color: #00346B;
		a{
			text-decoration: none;
		}
}
.footer-copyright{
	line-height: 15px;
		text-align: center;
		font-size: 12px;
		color: #222;
		    font-style: italic;
}

.payment {
		margin: 20px auto 20px;
			::v-deep .ou-donation-btn{
				width: 300px;
				max-width: 100%;
				margin: 0 auto;
				justify-content: center;
				align-items: center;
		}
}

.frequency{
	margin-top: 20px;
}
// .ote-donation-form .payment-info ::v-deep .styled-radio-container--ou-donation{
// 		.radio-part{
// 	  @media only screen and (min-width: 720px) {
// 			min-width: 50%;
// 			max-width: 50%;
// 		}
// 		}
// }

label{
	  line-height: normal;
}
.checktext{
	margin-top: -20px;
	line-height: 21px;
	p{
		margin-top: 5px;
	}
}

.doublepay{
	display: flex;
    align-items: center;
    justify-content: center;
}

.ote-donation-form ::v-deep .styled-radio--ou-donation.styled-radio label{
	font-size: 16px;
}
.ote-donation-form ::v-deep .styled-radio--ou-donation .amount_other__wrapper input[type=number]{
	font-size: 16px;
}
.ote-donation-form ::v-deep .styled-radio--ou-donation .amount_other__wrapper{
	    margin-bottom: 5px;
    margin-top: 5px;
}

.ote-donation-form ::v-deep .payment-info .styled-radio-container--ou-donation.styled-radio-container .radio-part{
			min-width: 50%;
			max-width: 50%;
}
</style>

